import { X } from "lucide-react";

const EventLogSkeleton = ({ setShowEmployeeActivity, rows = 8 }) => {
  return (
    <div
      style={{
        width: "100%",
        padding: "20px",
        background: "#fff",
        height: "100%",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          marginBottom: "20px",
          paddingBottom: "10px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          className='evtlog__skeleton-shimmer'
          style={{
            width: "200px",
            height: "16px",
          }}
        ></div>
        <span onClick={() => setShowEmployeeActivity(false)}>
          <X />
        </span>{" "}
      </div>

      <div
        style={{
          width: "100%",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "140px 160px 1fr 200px 120px",
            gap: "16px",
            padding: "12px 16px",
            background: "#f9fafb",
            borderBottom: "1px solid #e5e7eb",
            fontSize: "11px",
            fontWeight: "600",
            color: "#6b7280",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
          className='evtlog__table-header'
        >
          <div>TIMESTAMP</div>
          <div>TYPE</div>
          <div>EVENT DESCRIPTION</div>
          <div>LOCATION</div>
          <div>Device</div>
        </div>

        <div style={{ background: "#fff" }}>
          {Array.from({ length: rows }).map((_, index) => (
            <div
              key={index}
              style={{
                display: "grid",
                gridTemplateColumns: "140px 160px 1fr 200px 120px",
                gap: "16px",
                padding: "16px",
                borderBottom: index === rows - 1 ? "none" : "1px solid #f3f4f6",
                alignItems: "center",
              }}
              className='evtlog__skeleton-row'
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                className='evtlog__cell-timestamp'
              >
                <div
                  className='evtlog__skeleton-shimmer'
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "4px",
                    flexShrink: "0",
                  }}
                ></div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    className='evtlog__skeleton-shimmer'
                    style={{
                      width: "40px",
                      height: "12px",
                    }}
                  ></div>
                  <div
                    className='evtlog__skeleton-shimmer'
                    style={{
                      width: "60px",
                      height: "12px",
                    }}
                  ></div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                className='evtlog__cell-type'
              >
                <div
                  className='evtlog__skeleton-shimmer'
                  style={{
                    width: "100px",
                    height: "28px",
                    borderRadius: "4px",
                  }}
                ></div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                className='evtlog__cell-description'
              >
                <div
                  className='evtlog__skeleton-shimmer'
                  style={{
                    width: "85%",
                    height: "14px",
                  }}
                ></div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                className='evtlog__cell-location'
              >
                <div
                  className='evtlog__skeleton-shimmer'
                  style={{
                    width: "14px",
                    height: "14px",
                    borderRadius: "3px",
                    flexShrink: "0",
                  }}
                ></div>
                <div
                  className='evtlog__skeleton-shimmer'
                  style={{
                    width: "140px",
                    height: "12px",
                  }}
                ></div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                className='evtlog__cell-device'
              >
                <div
                  className='evtlog__skeleton-shimmer'
                  style={{
                    width: "14px",
                    height: "14px",
                    borderRadius: "3px",
                    flexShrink: "0",
                  }}
                ></div>
                <div
                  className='evtlog__skeleton-shimmer'
                  style={{
                    width: "60px",
                    height: "12px",
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventLogSkeleton;
